// src/pages/approach.js
import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { motion } from "framer-motion";
import "./approach.css";

const approachPoints = [
  {
    title: "Rigorous AI Ethics",
    desc: "Every solution we build undergoes extensive ethical review to ensure responsible AI deployment.",
  },
  {
    title: "Security by Design",
    desc: "Security isn't an add-on—it's woven into every line of code and every system architecture decision.",
  },
  {
    title: "Human-Centered Solutions",
    desc: "We design for the people who use our systems, ensuring intuitive interfaces that enhance decision-making.",
  },
  {
    title: "Continuous Adaptation",
    desc: "Our solutions evolve with the threat landscape, continuously learning and improving.",
  },
];

const Approach = () => {
  return (
    <div className="approach-page-container app-content">
      <Navbar />

      <section className="about-approach">
        <motion.div
          className="approach-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, amount: 0.2 }}
        >
          <h2>Our Approach</h2>
          <div className="underline"></div>

          <p>
            We believe that true security comes from a deep understanding of both the technological
            landscape and the human elements at play. Our approach combines:
          </p>

          <div className="approach-points">
            {approachPoints.map((item, i) => (
              <motion.div
                key={item.title}
                className="approach-point"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: (i + 1) * 0.1 }}
              >
                <span>{`0${i + 1}`}</span>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </section>

      <Footer />
    </div>
  );
};

export default Approach;
